import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CaptureHistoryItemTypeBaseComponent } from '../capture-history-item-type-base/capture-history-item-type-base.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';

@Component({
  selector: 'app-capture-history-item-type-nuvem-arp-claim-imported',
  templateUrl: './capture-history-item-type-nuvem-arp-claim-imported.component.html',
  imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent, DatePipe]
})
export class CaptureHistoryItemTypeNuvemArpClaimImportedComponent extends CaptureHistoryItemTypeBaseComponent {
}
